import { Component, ReactNode, ReactPortal } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: ReactNode;
}

class ModalPortal extends Component<Props> {
  render(): ReactPortal {
    let modalRoot = document.getElementById('modal-root');
    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.setAttribute('id', 'modal-root');
      document.body.appendChild(modalRoot);
    }

    const portal = createPortal(this.props.children, document.getElementById(
      'modal-root'
    ) as HTMLElement);
    return portal;
  }
}

export default ModalPortal;
